module.exports = __webpack_public_path__ + "img/doubleTicket_uncheck.ac09062c.png";